import React from 'react';
import ContentCard from '../ContentCard/ContentCard';
import SectionTitle from '../SectionTitle/SectionTitle';
import styles from './TextSummaryCard.module.css';

interface TextSummaryCardProps {
  title?: string;
  titleAccessory?: React.ReactNode;
  titleAction?: React.ReactNode;
  value?: string | null;
  emptyText: string;
  className?: string;
  scrollable?: boolean;
}

const TextSummaryCard: React.FC<TextSummaryCardProps> = ({
  title,
  titleAccessory,
  titleAction,
  value,
  emptyText,
  className,
  scrollable = false,
}) => {
  const trimmedValue = typeof value === 'string' ? value.trim() : '';

  return (
    <div
      className={[
        styles.root,
        scrollable ? styles.scrollable : '',
        className,
      ].filter(Boolean).join(' ')}
    >
      {(title || titleAccessory || titleAction) && (
        <div className={styles.headerRow}>
          <div className={styles.titleGroup}>
            {title ? <SectionTitle as="h2" text={title} /> : null}
            {titleAccessory}
          </div>
          {titleAction}
        </div>
      )}
      <div className={styles.body}>
        <ContentCard>
          {trimmedValue ? (
            <p className={styles.summaryText}>{trimmedValue}</p>
          ) : (
            <p className={styles.summaryEmpty}>{emptyText}</p>
          )}
        </ContentCard>
      </div>
    </div>
  );
};

export default TextSummaryCard;
